import axios from '../axios'

/* 
 * 商品模块
 */
// 发布
export const add = (data) => {
    return axios({
        url: '/goods/add',
        method: 'post',
        data
    })
}
// 保存
export const save = (data) => {
    return axios({
        url: '/goods/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/goods/delete',
        method: 'post',
        data
    })
}
// 查询
export const findPage = (data) => {
    return axios({
        url: '/goods/findPage',
        method: 'post',
        data
    })
}
export const findPageAll = (data) => {
    return axios({
        url: '/goods/findPageAll',
        method: 'post',
        data
    })
}
export const getStatus = (data) => {
    return axios({
        url: '/goods/getStatus',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/goods.js